import { api } from './client'

export type ApiKeyScope = 'partner' | 'storefront' | 'shop_auth'

// Quyền đọc theo resource của partner API — khớp entity.PartnerPermissions ở
// server (cùng thứ tự hiển thị). Khoá partner chỉ gọi được API đã chọn.
export const PARTNER_PERMISSIONS = [
    'growers.read',
    'areas.read',
    'tea_types.read',
    'employees.read',
    'grower_faces.read',
    'care_logs.read',
    'money_loop_metrics.read',
    'business_metrics.read',
] as const

export type PartnerPermission = (typeof PARTNER_PERMISSIONS)[number]

// ApiKey is the metadata view returned by the list endpoint. The secret is
// never included — it exists only in the CreatedApiKey returned once at create.
export interface ApiKey {
    id: string
    name: string
    key_prefix: string
    // Missing on payloads from servers older than the scope column.
    scope?: ApiKeyScope
    // null = khoá partner tạo trước khi có phân quyền → toàn quyền. Khoá
    // storefront/shop_auth luôn null (không dùng phân quyền này).
    permissions?: PartnerPermission[] | null
    expires_at?: string | null
    created_by?: string | null
    created_at: string
    revoked_at?: string | null
}

export interface CreateApiKeyRequest {
    name: string
    // scope: omit for a partner key. 'storefront' and 'shop_auth' need
    // api_keys.write_storefront.
    scope?: ApiKeyScope
    // permissions: bắt buộc (không rỗng) với khoá partner; bỏ trống với khoá
    // storefront/shop_auth.
    permissions?: PartnerPermission[]
    // expires_at: RFC3339 timestamp or YYYY-MM-DD date; omit/null for a
    // permanent key.
    expires_at?: string | null
}

// CreatedApiKey carries the one-time plaintext `key`. It is returned only from
// create and can never be retrieved again.
export interface CreatedApiKey {
    id: string
    name: string
    key: string
    key_prefix: string
    permissions?: PartnerPermission[] | null
    expires_at?: string | null
    created_at: string
}

export const apiKeyApi = {
    list: () => api.get<ApiKey[]>('/api-keys'),
    create: (data: CreateApiKeyRequest) =>
        api.post<CreatedApiKey>('/api-keys', data),
    revoke: (id: string) => api.delete(`/api-keys/${id}`),
    updatePermissions: (id: string, permissions: PartnerPermission[]) =>
        api.put<ApiKey>(`/api-keys/${id}/permissions`, { permissions }),
}
